module.exports = __webpack_public_path__ + "media/components/signup-page/static/background-4ba6bef9b08f35a03d7a0ab6e5af2689.jpg";